import InputMask from 'react-input-mask';
import { forwardRef, useState } from "react";
import { Input } from 'reactstrap';
import ReactSelect from 'react-select';

const Year = forwardRef((props, ref) => {
    let [value, updateValue] = useState(props.value);
    let className = '';

    let options = [];
    for (let ano = 2099; ano >= 1900; ano--) {
        options.push({ label: ano.toString(), value: ano });
    }

    const handleChangeText = element => {
        const value = element.target.value.replace(/[^0-9]/g, '');

        let newVal = value;
        const max = 2099;
        const min = 1900;
        const maxLength = 4;

        newVal = newVal.length > maxLength ? newVal.toString().slice(0, 4) : newVal

        if (newVal.length == maxLength) {
            if (value > max) {
                newVal = max
            } else if (value < min) {
                newVal = min
            }
        }

        element.target.value = newVal;
        updateValue(element.target.value);
        props.onChange(element);
    };

    const handleChangeSelect = element => {
        const target = {
            name: props.name,
            type: 'select',
            ...element
        }

        updateValue(element?.value);
        props.onChange({ target });
    };

    if (props.error) {
        className = "is-invalid";
    }
    return (
        <div ref={ref}>
            {!props.selectable ? (
                <Input
                    id={'id_' + props.name}
                    onChange={handleChangeText}
                    className={className}
                    value={props.value}
                    type={props.type}
                    name={props.name}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    max={2099}
                    min={1900}
                    readOnly={props.readOnly}
                    autoFocus={props.autoFocus ? true : false}
                />
            ) : (
                <ReactSelect
                    autoFocus={props.autoFocus ? true : false}
                    name={props.name}
                    placeholder={'Selecione'}
                    options={options}
                    onChange={handleChangeSelect}
                    value={{ label: value && value.toString(), value }}
                    isDisabled={props.readOnly}
                    isSearchable={true}
                    isClearable={true}
                />
            )}

            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
})
export default Year;
